import { render, staticRenderFns } from "./MessagesSettings.vue?vue&type=template&id=1a2159bb&scoped=true"
import script from "./MessagesSettings.vue?vue&type=script&lang=js"
export * from "./MessagesSettings.vue?vue&type=script&lang=js"
import style0 from "./MessagesSettings.vue?vue&type=style&index=0&id=1a2159bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2159bb",
  null
  
)

export default component.exports